import { render, staticRenderFns } from "./FileUpdateNotification.vue?vue&type=template&id=37ad86aa"
import script from "./FileUpdateNotification.vue?vue&type=script&lang=js"
export * from "./FileUpdateNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports